module.exports = __webpack_public_path__ + "static/img/facilities-text-4.fbb75e69.png";